import React, { useEffect, useState, useRef, useContext } from 'react';

import styles from './editcover.module.scss';

// import AppImage from '../AppImage';
import { AdminContext } from '../../context/AdminContext';
import Api from '../../api';
import FileUpload from '../FileUpload';
import AppIcons from '../../icons';
import Avatar from '../Avatar';
import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';
import blankGroup from '../../../../assets/imgs/blank-group-picture.png';

const EditImage = ({
  content,
  groupInfo,
  setGroupInfo,
  setError,
  className = 'nothing',
  personalInfo = false,
}) => {
  const [typeState, setTypeState] = useState('');
  const [loadingImage, setLoadingImage] = useState(false);
  const [coverSize, setCoverSize] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [openProfileImageMobile, setOpenProfileImageMobile] = useState(false);
  const profileBoxRefMobile = useRef(null);
  const [image, setImage] = useState({
    name: groupInfo?.imageName,
    fileId: groupInfo?.imageId,
  });
  const {
    setTrigger,
    themeColor,
    setNotificationModal,
    groupState,
    themeMode,
  } = useContext(AdminContext);

  const checkIfClickedOutside = (e) => {
    // If the menu is open and the clicked target is not within the menu,
    // then close the menu
    if (
      openProfileImageMobile &&
      profileBoxRefMobile.current &&
      !profileBoxRefMobile.current.contains(e.target)
    ) {
      setOpenProfileImageMobile(false);
      console.log('firstdepen');
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [openProfileImageMobile]);
  useEffect(() => {
    setError('');
    setImage({ name: groupInfo?.imageName, fileId: groupInfo?.imageId });
  }, [
    groupInfo?.imageId,
    groupInfo?.imageName,
    groupInfo?.title,
    groupInfo?.description,
  ]);
  useEffect(() => {
    if (selectedFile !== null) {
      if (typeState == 'userImage') {
        submitForm();
      }
    }
  }, [selectedFile]);
  const submitForm = () => {
    const formData = new FormData();
    formData.append('file', selectedFile);
    setLoadingImage(true);
    Api.uploadGroupImage(formData)

      .then((res) => {
        setGroupInfo({
          ...groupInfo,
          imageId: res.data.response.fileId,
          imageName: res?.data?.url,
        });
        setLoadingImage(false);
        // setImage({ name: res?.data?.url, fileId: res.data.response.fileId });
      })
      .catch((err) => {
        setLoadingImage(false);
        setError(err.response.data.message);
      });
  };

  const openProfileImageBox = (e) => {
    e.preventDefault();
    setTypeState('userImage');
    setOpenProfileImageMobile(!openProfileImageMobile);
  };

  const removeImage = () => {
    setGroupInfo({ ...groupInfo, fileId: '', imageId: '', imageName: '' });
    setImage({ name: '', fileId: '' });
  };

  console.log('image', groupInfo, image, groupState);
  return (
    <>
      <div
        className={`relative flex flex-row justify-center items-center w-full h-auto ${className}`}
      >
        <Avatar
          width={100}
          height={100}
          containerclassName={`cursorDefault relative`}
          className={`cursorDefault  ${
            !(image?.name?.length != 0 && image?.name != undefined) &&
            styles.imageStyleBorder
          }`}
          src={
            image?.name?.length != 0 && image?.name != undefined
              ? image?.name
              : groupState?.typeId == 2 || !groupState
              ? !personalInfo
                ? blankGroup
                : blanckUser
              : blanckUser
          }
          local={
            image?.name?.length != 0 && image?.name != undefined ? false : true
          }
        >
          <div
            className={`${styles.uploadButtonUserImage} mainBg`}
            onClick={(e) => openProfileImageBox(e)}
          >
            <AppIcons.EditIcon height={18} width={18} fill={`#ffffff`} />
          </div>
          {openProfileImageMobile && (
            <div
              className={`${styles.absoluteprofileImage} uploadCoverButton`}
              ref={profileBoxRefMobile}
            >
              <FileUpload
                cropMode
                cropContainer={`${styles.cropModal}`}
                suitableAspect={1 / 1}
                selectedFile={selectedFile}
                setSelectedFile={setSelectedFile}
                loading={loadingImage}
                setLoading={setLoadingImage}
                loadingStyle={styles.lds_ring}
                height={'h-[100%] '}
                id="user"
              >
                <div className={`flex flex-row justify-start items-center`}>
                  <AppIcons.UploadImageIcon height={18} width={18} />

                  <span
                    className={`cursor-pointer  ml-[15px] ${
                      themeMode != 'white' && 'textWhite'
                    }`}
                    onClick={() => {
                      setTypeState('userImage');
                    }}
                  >
                    آپلود
                  </span>
                </div>
              </FileUpload>

              <div onClick={() => removeImage()}>
                <div className={`flex flex-row justify-start items-center`}>
                  <AppIcons.DeleteIcon height={18} width={18} />

                  <p className={`ml-[15px]`}> حذف</p>
                </div>
              </div>
            </div>
          )}
        </Avatar>
      </div>
    </>
  );
};

export default EditImage;
